import { useState, useEffect, useCallback } from "react";
import { companyAPI } from "../services/api";
import i18n from "../i18n";

export const useCompanyInfo = () => {
  const [companyInfo, setCompanyInfo] = useState(null);

  const fetchCompanyInfo = useCallback(async () => {
    try {
      setCompanyInfo((prev) => ({ ...prev, loading: true, error: null }));

      const response = await companyAPI.getCompanyInfo();

      // Cache in localStorage so useCountryConfig can resolve the country code
      // without an extra API call (used by employee form, language defaults, etc.)
      try {
        localStorage.setItem('company_info', JSON.stringify(response));
      } catch (_) {}

      // Apply default language for Gulf tenants only when user has no saved preference at all
      try {
        const userRaw = localStorage.getItem('user_data') || sessionStorage.getItem('user_data');
        const user = userRaw ? JSON.parse(userRaw) : null;
        const storedLang = localStorage.getItem('i18nextLng')?.split('-')[0];
        if (!user?.preferred_language && !storedLang) {
          const cc = response?.company?.country_code;
          if (cc === 'QA' || cc === 'SA') {
            i18n.changeLanguage('en');
          }
        }
      } catch (_) {}

      setCompanyInfo(response);
    } catch (error) {
      console.error("Erreur lors du chargement des informations société:", error);
      setCompanyInfo((prev) => ({
        ...prev,
        loading: false,
        error: error.message || i18n.t("common.errorLoading"),
      }));
    }
  }, []);

  useEffect(() => {
    fetchCompanyInfo();
  }, [fetchCompanyInfo]);

  const refreshCompanyInfo = useCallback(() => {
    fetchCompanyInfo();
  }, [fetchCompanyInfo]);

  return {
    ...companyInfo,
    refreshCompanyInfo,
  };
};
